import { useContext, useMemo } from 'react'
import GlobalsContext from 'sb-hooks/GlobalsContext'


const getAbValue = (key, abTests) => {
  const abValue = abTests[key]

  if (!abTests) {
    console.error('AbTests are not defined!')
    return 'a'
  }

  if (!abValue) {
    console.error(`AbTests item by key "${key}" not found!`)

    return 'a'
  }

  if (typeof abValue === 'string') {
    console.error(`AbTests item by key "${key}" is String!`)

    return abValue
  }

  return abValue.value || 'a'
}

/**
 *
 * @param {String|Object} abKeys
 * @returns {String|Object} - ab values
 */
const useAbValues = (abKeys) => {
  const { globals = {} } = useContext(GlobalsContext)

  const abTests = globals.abTests || {}

  return useMemo(() => {
    if (typeof abKeys === 'string') {
      return getAbValue(abKeys, abTests)
    }

    return Object.keys(abKeys)
      .reduce((abValues, key) => {
        abValues[key] = getAbValue(abKeys[key], abTests)

        return abValues
      }, {})
  }, [ abTests, abKeys ])
}


export default useAbValues
